import _ from 'lodash';
import dayjs from 'dayjs';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import FailureCodesList from './FailureCodesList';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import WorkOrderJobPlanes from './WorkOrderJobPlanes';
import TableSelect from '../../../Widgets/TableSelect';
import { Toolsform, MaterialForm } from './WorkOrderTasks';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';
import StyledTable from "../../../../../commons/styles/table";
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import themeSettings from '../../../../../commons/styles/themeSettings.json';
import { API_DEVICE } from '../../../../../commons/api';

import FailureCodeDetails from '../../EquipmentRegister/FailureCodeMaster/FailureCodeDetails';
import { Form, message, Select, Tabs, DatePicker, Input, Typography, Modal,Button } from 'antd';
import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitWorkOrder,
  getJobPlansList,
  // getJobPlanById,
  getWorkTypes,
  getHierarchyList,
  getStatus,
  getWorkOrderById
} from '../../../Utils/FormCalls';
import {
  StyledSubForm,
  StyledBox,
  StyledBoxLabel
} from '../../../CSS/style';

const { Option } = Select;
const { TextArea } = Input;

const WorkOrderForm = (props) => {
  const workOrderRef = useRef(null);
  const searchInput = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [fileData, setFileData] = useState(new FormData());
  //const [formObject, setFormObject] = useState({});
  //const [fileUploadList, setFileUploadList] = useState({});
  const [visible, setVisible] = useState(false);
  const [enableTask, setEnableTask] = useState({});
  //const [,setTranslationCache] = useState(props.translationCache || []);
  const [state, setState] = useState({
    deviceList: [],
    organisationsList: [],
    sitesList: [],
    workTypesList: [],
    statusList: [],
    formObject: props.formObject || {},
    activeKey: '1',
    selectedJobPlan: props.formObject && props.formObject.JobPlanName ? props.formObject.JobPlanName : '',
    jobplanActivekey: '1',
    hierarchyList: [],
    //visible: false,
    fileData: [],
    // enableTask: true,
    viewFCModal: false,
    fileUploadList: {},
    searchText: null
  });

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        let hierarchyList = await getHierarchyList();
        setState(prevState => ({ ...prevState, hierarchyList }));
      } catch (error) {
        message.warning(`${error.message}`);
      }
      let deviceList = await getDeviceList();
      setState(prevState => ({ ...prevState, deviceList }));
      let organisationsList = await getOrganisationsList();
      setState(prevState => ({ ...prevState, organisationsList }));
      let sitesList = await getSitesList();
      setState(prevState => ({ ...prevState, sitesList }));
      let JobPlansList = await getJobPlansList('Active');
      setState(prevState => ({ ...prevState, JobPlansList }));

      try {
        let statusList = await getStatus();
        setState(prevState => ({ ...prevState, statusList }));
        let APPRStatus = statusList && Array.isArray(statusList) ? statusList.filter((status) => status.Status === 'APPR') : [];
        let WOStatusId = APPRStatus && APPRStatus[0] ? APPRStatus[0].Id : undefined;
        let workTypesList = await getWorkTypes();
        setState(prevState => ({ ...prevState, workTypesList }));

        let EMWorkType = workTypesList && Array.isArray(workTypesList) ? workTypesList.filter((wType) => wType.WorkType === 'Emergency Maintenance') : [];
        let WorkTypeId = EMWorkType && EMWorkType[0] ? EMWorkType[0].Id : undefined;
        if (state.formObject && !state.formObject.Id) {
          handleChange(WOStatusId, 'WOStatusId');
          handleChange(WorkTypeId, 'WorkTypeId');
        }
      } catch (error) {
        // message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []); // Empty dependency array to mimic componentDidMount

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(state.formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      workOrderRef.current && workOrderRef.current.setFieldsValue(props.formObject);
    }

    if (props.formObject && Object.keys(props.formObject).length > 0) {
      if (props.formObject && props.formObject.Id) {
        handleChange(props.formObject.Id, 'WorkOrder');
      }
      setState(prevState => ({ ...prevState, formObject: props.formObject }));
    }
  }, [props.formObject]);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length > 0) {
      setState(prevState => ({
        ...prevState,
        formObject: props.formObject
      }));
    }
  }, [props.formObject]);

  const onDrawerCancel = (e) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    if (formObject.Equipment === undefined && e.target.tagName === 'DIV') {
      e.preventDefault();
      return message.error(`Please Click On Cancel`);
    } else {
      setVisible(false);
    }
  };

  const onModalOk = () => {
    setVisible(false);
  };

  const remove = (mainindex, key) => {
    let formObject = this.workOrderRef.current && this.workOrderRef.current.getFieldValue();
    let updatedFormObject = {
      ...formObject,
      [key]:
        formObject &&
        formObject[key] &&
        formObject[key].filter((tool, index) => index !== mainindex)
    };

    // Update the form values and state
    workOrderRef.current && workOrderRef.current.setFieldsValue(updatedFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: updatedFormObject
    }));
  };

  const _getDataById = async (Id) => {
    let { statusList, workTypesList } = state;
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/EWODetails/');
    let formId = Id ? Id : base64_decode(path[1]);
    if (formId !== 'new') {
      // setState(prevState => ({ ...prevState, enableTask: false }));
      setEnableTask(false);

      let data = await getWorkOrderById(formId, 'withId');
      formObject = data ? data : {};
      _.cloneDeepWith(formObject, (value) => {
        return value !== null
          ? {
            ...value,
            ...(value['ActualStart'] ? (value['ActualStart'] = moment.utc(value.ActualStart, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['ActualEnd'] ? (value['ActualEnd'] = moment.utc(value.ActualEnd, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['RecordDate'] ? (value['RecordDate'] = moment.utc(value.RecordDate, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['JobPlan'] && value['JobPlan']['TaskData'] && value['JobPlan']['TaskData'].map((item, i) => {
              return value['JobPlan']['TaskData'][i]
                ? (value['JobPlan']['TaskData'][i]['StartTime'] ? (value['JobPlan']['TaskData'][i]['StartTime'] = dayjs.utc(value['JobPlan']['TaskData'][i]['StartTime'], 'YYYY-MM-DD HH:mm:ss').local()) : null,
                  value['JobPlan']['TaskData'][i]['EndTime'] ? (value['JobPlan']['TaskData'][i]['EndTime'] = dayjs.utc(value['JobPlan']['TaskData'][i]['EndTime'], 'YYYY-MM-DD HH:mm:ss').local()) : null)
                : null;
            }))
          }
          : _.noop();
      });
    } else if (Id) {
      let data = await getWorkOrderById(Id, 'withId');
      formObject = data ? data : {};
      _.cloneDeepWith(formObject, (value) => {
        return value !== null
          ? {
            ...value,
            ...(value['ActualStart'] ? (value['ActualStart'] = moment.utc(value.ActualStart, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['ActualEnd'] ? (value['ActualEnd'] = moment.utc(value.ActualEnd, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['RecordDate'] ? (value['RecordDate'] = moment.utc(value.RecordDate, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value['JobPlan'] && value['JobPlan']['TaskData'] && value['JobPlan']['TaskData'].map((item, i) => {
              return value['JobPlan']['TaskData'][i]
                ? (value['JobPlan']['TaskData'][i]['StartTime'] ? (value['JobPlan']['TaskData'][i]['StartTime'] = moment.utc(value['JobPlan']['TaskData'][i]['StartTime'], 'YYYY-MM-DD HH:mm:ss').local()) : null,
                  value['JobPlan']['TaskData'][i]['EndTime'] ? (value['JobPlan']['TaskData'][i]['EndTime'] = moment.utc(value['JobPlan']['TaskData'][i]['EndTime'], 'YYYY-MM-DD HH:mm:ss').local()) : null)
                : null;
            }))
          }
          : _.noop();
      });
    } else {
      if (formObject && formObject.Id) {
        handleChange(formObject.Id, 'WorkOrder');
        let WAPPRStatus = statusList && Array.isArray(statusList) ? statusList.filter((status) => status.Status === 'WAPPR') : [];
        let WOStatusId = WAPPRStatus && WAPPRStatus[0] ? WAPPRStatus[0].Id : undefined;
        handleChange(WOStatusId, 'WOStatusId');
        let EMWorkType = workTypesList && Array.isArray(workTypesList) ? workTypesList.filter((wType) => wType.WorkType === 'Emergency Maintenance') : [];
        let WorkTypeId = EMWorkType && EMWorkType[0] ? EMWorkType[0].Id : undefined;
        handleChange(WorkTypeId, 'WorkTypeId');
      }
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
    }
    setState(prevState => ({ ...prevState, formObject }));

    if (formObject && workOrderRef.current) {
      workOrderRef.current.setFieldsValue(formObject);
    }
  };

  const handleChange = async (value, key) => {
    setState(prevState => {
      const updatedFormObject = {
        ...prevState.formObject,
        [key]: value,
      };

      if (workOrderRef && workOrderRef.current) {
        workOrderRef.current.setFieldsValue(updatedFormObject);
      }

      return {
        ...prevState,
        [key]: value,
        formObject: updatedFormObject,
      };
    });
  };



  const fileupload = async (values, key, fileDataObject) => {
    let currentFormObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    let { fileUploadList } = state;

    if (currentFormObject[key]) {
      currentFormObject[key].push(...values);
    } else {
      currentFormObject[key] = values;
    }

    currentFormObject[key] = currentFormObject[key]?.reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    currentFormObject = {
      ...currentFormObject,
      [key]: currentFormObject[key]
    };

    const fileData = new FormData();
    fileData.append('files', fileDataObject);

    let WO = [...(fileUploadList.WO || [])];
    WO.push({ fileDataObject });
    const updatedFileUploadList = {
      ...fileUploadList,
      WO
    };

    workOrderRef.current && workOrderRef.current.setFieldsValue(currentFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: currentFormObject,
      fileUploadList: updatedFileUploadList
    }));
  };
  const onFinish = async (values, key, fileData) => {
    let currentFormObject = workOrderRef.current && workOrderRef.current.getFieldsValue();

    // Update the form object with the new values
    const updatedFormObject = {
      ...currentFormObject,
      [key]: {
        ...currentFormObject[key],
        ...values,
      },
    };

    // Update the state
    //setFormObject(updatedFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: updatedFormObject
    }));
    setFileData(fileData); // Update fileData state

    // Set the updated form values
    workOrderRef.current && workOrderRef.current.setFieldsValue(updatedFormObject);
  };


  const onFormsubmit = async () => {
    let { fileUploadList } = state;

    let formObjectRef = workOrderRef.current && workOrderRef.current.getFieldsValue();
    let formObject1 = {
      ...formObjectRef,
      RecordDate: formObjectRef.RecordDate ? dayjs(formObjectRef.RecordDate).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      ActualStart: formObjectRef.ActualStart ? dayjs(formObjectRef.ActualStart).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      ActualEnd: formObjectRef.ActualEnd ? dayjs(formObjectRef.ActualEnd).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      Type: 'Emergency'
    };
    let statusResponse = await submitWorkOrder(formObject1, fileUploadList);
    if (statusResponse && statusResponse.message) {
      _getDataById(statusResponse.Id);
      message.success('WorkOrder Submitted Successfully');
      props.navigate('/rubus/AMM/EWOList');
      onReset();
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    workOrderRef.current && workOrderRef.current.resetFields();
  };

  const handleSelect = (value, subindex, keyName, selectedObject) => {
    let currentFormObject = workOrderRef.current && workOrderRef.current.getFieldValue();
    let TaskData = currentFormObject && currentFormObject[keyName] ? currentFormObject[keyName] : [];

    // Create a new array to avoid mutating the state directly
    const updatedTaskData = TaskData.map((item, index) => {
      if (index === subindex) {
        return {
          ...item,
          AvailableQuantity: selectedObject[0]['AvailableQuantity'],
          Description: selectedObject[0]['Description'],
        };
      }
      return item;
    });

    // Update the form object with the modified TaskData
    const updatedFormObject = {
      ...currentFormObject,
      [keyName]: updatedTaskData,
    };
    // Update the state and the form values
    //setFormObject(updatedFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: updatedFormObject
    }));
    workOrderRef.current && workOrderRef.current.setFieldsValue(updatedFormObject);
  };
  const getDisabledHours = (e, key) => {
    let hours = [];
    let minutes = [];
    let seconds = [];
    let StartDateTime = '';
    let EndDateTime = '';
    let StartDate = '';
    let EndDate = '';

    if (key === 'ActualStart') {
      StartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
      EndDateTime = moment
        .utc(workOrderRef.current &&
          workOrderRef.current.getFieldValue() &&
          workOrderRef.current.getFieldValue('ActualEnd'),
          'YYYY-MM-DD HH:mm'
        )
        .local();

      StartDate = moment(e).format('YYYY-MM-DD');
      EndDate = moment
        .utc(workOrderRef.current &&
          workOrderRef.current.getFieldValue() &&
          workOrderRef.current.getFieldValue('ActualEnd')
        )
        .local()
        .format('YYYY-MM-DD');
    } else if (key === 'ActualEnd') {
      StartDateTime = moment
        .utc(workOrderRef.current &&
          workOrderRef.current.getFieldValue() &&
          workOrderRef.current.getFieldValue('ActualStart'),
          'YYYY-MM-DD HH:mm'
        )
        .local();
      EndDateTime = moment(e).format('YYYY-MM-DD HH:mm');

      StartDate = moment
        .utc(workOrderRef.current &&
          workOrderRef.current.getFieldValue() &&
          workOrderRef.current.getFieldValue('ActualStart')
        )
        .local()
        .format('YYYY-MM-DD');
      EndDate = moment(e).format('YYYY-MM-DD');
    }
    if (
      key === 'ActualStart' &&
      moment(StartDate).isSame(
        moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours()
      )
    ) {
      for (let i = 0; i <= 24; i++) {
        if (i > moment(EndDateTime).hours()) {
          hours.push(i);
        }
      }
      if (moment(StartDateTime).hours() === moment(EndDateTime).hours()) {
        for (var i = 0; i <= 60; i++) {
          if (i > moment(EndDateTime).minutes() - 1) {
            minutes.push(i);
          }
        }
        if (moment(StartDateTime).seconds() === moment(EndDateTime).seconds()) {
          for (let i = 0; i <= 60; i++) {
            if (i < moment(EndDateTime).seconds() - 1) {
              seconds.push(i);
            }
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes,
        disabledSeconds: () => seconds
      };
    } else if (
      key === 'ActualEnd' &&
      moment(StartDate).isSame(
        moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours()
      )
    ) {
      for (let i = 0; i < moment(StartDateTime).hours(); i++) {
        if (i < 25) {
          hours.push(i);
        }
      }

      if (moment(StartDateTime).hours() === moment(EndDateTime).hours()) {
        for (let i = 0; i < moment(StartDateTime).minutes() + 1; i++) {
          if (i < 61) {
            minutes.push(i);
          }
          if (moment(StartDateTime).seconds() === moment(EndDateTime).seconds()) {
            for (let i = 0; i < moment(StartDateTime).seconds() + 1; i++) {
              if (i < 61) {
                seconds.push(i);
              }
            }
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes,
        disabledSeconds: () => seconds
      };
    }
  };

  const NestedSelectOnChange = (value, key) => {
    let currentFormObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      [key]: [...value]
    };
    //setFormObject(currentFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: currentFormObject
    }));
    workOrderRef.current && workOrderRef.current.setFieldsValue(currentFormObject);
  };


  const fileAppend = (fileDataObject) => {
    // Append the new file to the FormData object
    fileData.append('files', fileDataObject);

    // Update the state with the new FormData object
    setFileData(new FormData(fileData)); // Create a new FormData instance to trigger re-render
  };

  const handleTotalDownTime = (formObject1) => {
    let { formObject } = state;
    const updatedFormObject = {
      ...formObject,
      ...(formObject1 || {})
    };
    //setFormObject(updatedFormObject);
    setState((prevState) => ({
      ...prevState,
      formObject: updatedFormObject
    }));
    if (workOrderRef.current) {
      workOrderRef.current.setFieldsValue(updatedFormObject);
    }
  };

  const onFCModalSubmit = () => {
    setVisible(false);
  };

  const onFCModalCancel = () => {
    setVisible(false);
  };

  const getDeviceData = (key) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setVisible(true);
        // setFormObject(workOrderRef.current && workOrderRef.current.getFieldsValue());
        setState((prevState) => ({
          ...prevState,
          [key]: true,
          formObject: workOrderRef.current && workOrderRef.current.getFieldsValue()
        }));
        setVisible(true);
        // Assuming you want to set the key to true in some state, you might need to manage that state as well
        // setSomeState({ ...someState, [key]: true }); // Uncomment and modify as needed
      })
      .catch(function () { });
  };

  const TableDropdownChange = (value, modal) => {
    let updatedFormObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    updatedFormObject = {
      ...updatedFormObject,
      DeviceAlias: value.AliasCode,
      Equipment: value.AliasCode,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      EquipmentDescription: value.Name,
      LocationId: value.Asset,
      AssetDisplayCode: value.AssetDisplayCode,
      LocationDescription: value.AssetDescription
    };

    if (workOrderRef.current) {
      workOrderRef.current.setFieldsValue(updatedFormObject);
    }
    setVisible(false);
    // setFormObject(updatedFormObject);
    // setEnableTask(false);
    setVisible(false);
    setState((prevState) => ({
      ...prevState,
      formObject: updatedFormObject,
      [modal]: false
    }));
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setState(prevState => ({ ...prevState, searchText: selectedKeys[0] }));
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const datepickerchange = (date, dateString, key) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      [key]: date
    };
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setState(prevState => ({ ...prevState, formObject }));
  };
  const columns = [
    {
      title: translation(props.translationCache, 'Type'),
      dataIndex: 'Type',
      key: 'Type',
      render: (text) => <div>{translation(props.translationCache, text)}</div>
    },
    {
      title: translation(props.translationCache, 'Name'),
      dataIndex: 'value',
      key: 'value'
    },
    {
      title: translation(props.translationCache, 'Description'),
      dataIndex: 'Description',
      key: 'Description'
    },
    {
      title: translation(props.translationCache, 'Remarks'),
      dataIndex: 'Remarks',
      key: 'Remarks'
    }
  ];

  const items = [
    {
      key: "2",
      label: translation(props.translationCache, constant.taskInformation),
      children: (
        <Form.Item name="JobPlan">
          {state.selectedJobPlan === '' ? (
            <WorkOrderJobPlanes
              addTask={enableTask}
              Equipment={state.formObject}
              handleTotalDownTime={handleTotalDownTime}
              fileData={state.fileData}
              onFinish={onFinish}
              formObject={state.formObject['JobPlan']}
              fileAppend={fileAppend}
            />
          ) : null}
        </Form.Item>
      )
    },
    {
      key: "3",
      label: translation(props.translationCache, constant.material),
      children: (
        <Form.Item>
          <MaterialForm
            formObject={workOrderRef.current !== null ? workOrderRef.current.getFieldsValue() : {}}
            onMaterialChange={handleSelect}
            onRemove={remove}
          />
        </Form.Item>
      )
    },
    {
      key: "4",
      label: translation(props.translationCache, constant.tools),
      children: (
        <Form.Item>
          <Toolsform
            formObject={workOrderRef.current !== null ? workOrderRef.current.getFieldsValue() : {}}
            onToolChange={handleSelect}
            onRemove={remove}
          />
        </Form.Item>
      )
    }
  ];

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  }; 
  const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 

  return (
    <>
      <Form
        ref={workOrderRef}
        name="EmergencyWorkOrder"
        theme={themeSettings}
        initialValues={state.formObject}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div style={{ marginLeft: '93%' }}>
          <Form.Item>
            <Button type='primary' theme={themeSettings} htmlType="submit">
              {translation(props.translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <StyledBoxLabel>
            <Typography.Title level={4}>
              {translation(props.translationCache, 'Trouble Reporting')}
            </Typography.Title>
          </StyledBoxLabel>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.WorkOrderdescription)}
              name="Description"
              style={{ width: '100%', flex: '50%', marginTop: '40px' }}
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(props.translationCache, 'Enter WorkOrderDescription')}
                style={{ width: '70%' }}
                onChange={(e) => handleChange(e.target.value, 'Description')}
              />
            </Form.Item>
            <Form.Item name="DeviceAlias"></Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                marginTop: '40px'
              }}
              label={translation(props.translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <Input
                disabled={true}
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Equipment')}
                suffix={
                  <DownOutlined
                    style={{
                      color: '#1a3b5c',
                      cursor: state.formObject && state.formObject.Id ? 'not-allowed' : null,
                      opacity: state.formObject && state.formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (state.formObject && !state.formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  />
                }
              />
            </Form.Item>
            <Modal
              open={visible}
              width={800}
              closable
              title={translation(props.translationCache, 'Hierarchy')}
              onOk={onModalOk}
              onCancel={onDrawerCancel}
            >
              <TableSelect
                data={tableData}
                translationCache={props.translationCache}
                key="Equipment"
                columns={[
                  {
                    title: translation(props.translationCache, 'Equipment'),
                    dataIndex: 'DisplayCode',
                    key: 'DisplayCode',
                    ...getColumnSearchProps('DisplayCode')
                  },
                  {
                    title: translation(props.translationCache, 'Equipment Description'),
                    dataIndex: 'Name',
                    key: 'Name',
                    ...getColumnSearchProps('Name')
                  }
                ]}
                handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
              />
            </Modal>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Autopopulate based on equipment selection')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.location)}
              name="AssetDisplayCode"
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(props.translationCache, 'Autopopulate based on equipment selection')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.locationDescription)}
              name="LocationDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(props.translationCache, 'Autopopulate based on equipment selection')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.recordedDate)}
              style={{ width: '100%', flex: '50%' }}
              name={'RecordDate'}
            >
              <DatePicker
                style={{ width: '70%' }}
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={translation(props.translationCache, 'Select RecordDate')}
                inputReadOnly={true}
                showNow={false}
                onChange={(date, dateString) => {
                  datepickerchange(date, dateString, 'RecordDate');
                }}
                showTime={{
                  defaultValue: moment('00:00:00', 'HH:mm:ss')
                }}
                disabledDate={(d) => !d || d.isAfter(moment().format('YYYY-MM-DD'))}
              />
            </Form.Item>
            <Form.Item name="SiteId"></Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.workType)}
              name="WorkTypeId"
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Work Type')}
                onChange={(value) => handleChange(value, 'WorkTypeId')}
                disabled={true}
              >
                {state.workTypesList.map((workType, index) => {
                  return (
                    <Option key={index} value={workType.Id}>
                      {translation(props.translationCache, workType.WorkType)}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.actualStart)}
              name={'ActualStart'}
            >
              <DatePicker
                style={{ width: '70%' }}
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={translation(props.translationCache, 'Select ActualStart')}
                inputReadOnly={true}
                showNow={false}
                onChange={(date, dateString) => {
                  datepickerchange(date, dateString, 'ActualStart');
                }}
                showTime={true}
                disabledDate={(d) => !d || d.isAfter(
                  workOrderRef.current && workOrderRef.current.getFieldValue() && workOrderRef.current.getFieldValue('ActualEnd')
                    ? dayjs(workOrderRef.current.getFieldValue('ActualEnd')).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                    : ''
                )}
                disabledTime={(e) => getDisabledHours(dayjs(e, 'YYYY-MM-DD HH:mm:ss'), 'ActualStart')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.actualEnd)}
              name={'ActualEnd'}
            >
              <DatePicker
                style={{ width: '70%' }}
                format="YYYY-MM-DD HH:mm:ss"
                showNow={false}
                placeholder={translation(props.translationCache, 'Select ActualEnd')}
                onChange={(date, dateString) => {
                  datepickerchange(date, dateString, 'ActualEnd');
                }}
                disabled={workOrderRef.current && workOrderRef.current.getFieldsValue() && workOrderRef.current.getFieldsValue()['ActualStart'] ? false : true}
                inputReadOnly={true}
                disabledDate={(d) => !d || d.isBefore(
                  workOrderRef.current && workOrderRef.current !== null && workOrderRef.current.getFieldValue() && workOrderRef.current.getFieldValue('ActualStart')
                    ? dayjs(workOrderRef.current && workOrderRef.current !== null && workOrderRef.current.getFieldValue() && workOrderRef.current.getFieldValue('ActualStart')).format('YYYY-MM-DD HH:mm:ss')
                    : ''
                )}
                disabledTime={(e) =>
                  getDisabledHours(dayjs(e, 'YYYY-MM-DD HH:mm:ss'), 'ActualEnd')
                }
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: moment('23:59:59', 'HH:mm:ss')
                }}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.status)}
              name="WOStatusId"
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Status')}
                onChange={(value) => handleChange(value, 'WOStatusId')}
                disabled={true}
              >
                {state.statusList.map((status, index) => {
                  return (
                    <Option key={index} value={status.Id}>
                      {status.Status}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, constant.SelectSite)}
                disabled={state.formObject && state.formObject.Id ? true : false}
                onChange={(e) => handleChange(e, 'SiteId')}
              >
                {state.sitesList && Array.isArray(state.sitesList) && state.sitesList.map((site, index) => {
                  return (
                    <Option key={index} value={site.Id}>
                      {site.Name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.TotalDowntime)}
              name={'TotalDowntime'}
              rules={[{ required: false, message: 'Autopopulte based on Task Estimated Duration!' }]}
              style={{ width: '100%', flex: '50%' }}
            >
              <InputComponent
                disabled={true}
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, constant.autopopulateBasedOnTask)}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              name="Attachments"
              label={translation(props.translationCache, constant.attachments)}
            >
              <FileBase64
                className={'formuploadInput'}
                downloadClassName={'formdownloadInput'}
                Attachments={state.formObject.Attachments}
                fileUpload={(values, key, fileDataObject) => {
                  fileupload(values, key, fileDataObject);
                }}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.summary)}
              name={'Summary'}
              style={{ width: '100%', flex: '50%' }}
            >
              <TextArea
                rows={3}
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Enter Summary')}
              />
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }}>
              <InputComponent style={{ display: 'none' }} />
            </Form.Item>
          </div>
        </StyledBox>
        <StyledBox>
          <StyledBoxLabel>
            <Typography.Title level={4}>
              {translation(props.translationCache, 'Failure Class')}
            </Typography.Title>
          </StyledBoxLabel>
          <div style={{ marginTop: '20px', marginLeft: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '5px' }}>
              <Button
                type='primary'
                theme={themeSettings}
                onClick={() => {
                  setState(prevState => ({ ...prevState, viewFCModal: true }));
                }}
              >
                {translation(props.translationCache, constant.addFailureClass)}
              </Button>
            </div>
            <Form.Item name="FailureCodes" style={{ width: '100%', flex: '50%' }}>
              {state.selectedJobPlan === '' ? (
                <FailureCodesList
                  NestedSelectOnChange={NestedSelectOnChange}
                  //formObject={state.formObject['JobPlan']}
                  translationCache={props.translationCache}
                  text={state.formObject && state.formObject['FailureCodes'] && state.formObject['FailureCodes'][0] && state.formObject['FailureCodes'][0]['value'] ? state.formObject['FailureCodes'][0]['value'] : ''}
                />
              ) : null}
              {state.formObject && state.formObject['FailureCodes'] && Array.isArray(state.formObject['FailureCodes']) ? (
                <StyledTable size="small"
                  style={{ padding: '20px 15px', border: '1px solid red !important' }}
                  columns={columns}
                  dataSource={state.formObject['FailureCodes'] && state.formObject['FailureCodes'].filter((item) => {
                    return item.Type !== undefined && item.Type !== 'Failure Class';
                  })}
                />
              ) : null}
            </Form.Item>
          </div>
        </StyledBox>
        <StyledBox>
          <StyledSubForm theme={themeSettings}>
            <Tabs defaultActiveKey="1" type="card" items={items} />
          </StyledSubForm>
        </StyledBox>
        <Modal
          open={state.viewFCModal}
          width={800}
          closable
          title={translation(props.translationCache, 'Add Failure Class')}
          footer={null}
          onCancel={onFCModalCancel}
        >
          <FailureCodeDetails
            EWOModal={true}
            onFCModalSubmit={onFCModalSubmit}
            onFCModalCancel={onFCModalCancel}
            formObject={{}}
          />
        </Modal>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderForm);